import {StyleSheet} from "react-native";
import {Color} from "@/lib/styles";
import {MarkedStyles} from "react-native-marked";
import {UserTheme} from "react-native-marked/src/theme/types";

export default StyleSheet.create({
    formTextInput: {
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: Color.Yellow,
        borderRadius: 7,
        paddingHorizontal: 8,
        fontSize: 16,
        textAlignVertical: "center",
        height: 42,
        color: Color.PrimaryText,
    },
    cardContainer: {
        width: "100%",
        borderRadius: 16,
        backgroundColor: Color.Background,
    },
    cardTitle: {
        backgroundColor: Color.PrimaryText,
        color: Color.Background,
        padding: 16,
        fontSize: 24,
        fontWeight: 600,
    },
    cardContents: {
        paddingHorizontal: 16,
        paddingVertical: 16,
        backgroundColor: Color.Background,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        gap: 16,
    }
})

export const markdownStyle: MarkedStyles = {
    h1: {
        fontSize: 24,
        fontWeight: 600,
    },
    h2: {
        fontSize: 20,
        fontWeight: 500,
    },
    paragraph: {
        margin: 0,
        padding: 0,
    },
    hr: {
        display: "none",
    },
    text: {
        fontSize: 16,
    },
    link: {
        textDecorationLine: "underline",
        fontStyle: "normal",
    }
};

export const markdownTheme: UserTheme = {
    spacing: {
        xs: 0, // unknown
        s: 0, // between header and separator
        m: 6, // between anything
        l: 12, // unknown, maybe between top headers
    },
    colors: {
        background: Color.Background,
        text: Color.PrimaryText,
        link: Color.Yellow,
        border: Color.Background,
        code: Color.PrimaryText,
    }
}